import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac7b954e")

_pushScopeId("data-v-ac7b954e")
const _hoisted_1 = { class: "detail-my-appliance-view" }
const _hoisted_2 = { class: "detail-my-appliance-view-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "detail-my-appliance-view-title-view" }, " 調理可能な最新機種のレシピを表示しています。 ", -1)
const _hoisted_4 = { class: "detail-my-appliance-view-text-view" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getMessage()), 1),
      _createVNode("div", {
        class: "detail-my-appliance-view-link-view",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickMyApplianceLink(...args)))
      }, " 家電登録・連携方法はこちら ")
    ])
  ]))
})